// @flow
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import useOutsideClick from '../utils/clickOutside';
import addOrg from '../../assets/icons/add_org.svg';
import hrOrg from '../../assets/icons/hr.svg';
import eduOrg from '../../assets/icons/edu.svg';
import eventOrg from '../../assets/icons/event.svg';

const styles = theme => ({
  searchResult: {
    padding: 15,
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.palette.grey[300] },
    display: 'flex',
  },
  resultName: {
    fontWeight: 'bold',
    fontSize: 16,
    color: 'black',
  },
  resultAddress: {
    fontSize: 16,
    color: '#778290',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  searchResultIcon: {
    width: 28,
    marginRight: 10,
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 28,
  },
  searchResultContent: {
    flexShrink: 0,
    flexGrow: 1,
    maxWidth: 'calc(100% - 38px)',
  },
});

type SearchResultProps = {
  name: string,
  address?: string | typeof undefined,
  classes: Object,
  type: string,
  id?: string | typeof undefined,
  onClick: Function,
};

const SearchResult = (result: SearchResultProps) => {
  const { t } = useTranslation();
  const { name, id, address, classes, type, onClick } = result;
  let img;
  switch (type) {
    case 'edu':
      img = eduOrg;
      break;
    case 'event':
      img = eventOrg;
      break;
    case 'new':
      img = addOrg;
      break;
    default:
      img = hrOrg;
      break;
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      role="button"
      className={classes.searchResult}
      tabIndex={0}
      onClick={() => {
        onClick({
          name,
          id,
        });
      }}
    >
      <img alt="search result" src={img} className={classes.searchResultIcon} />
      <div className={classes.searchResultContent}>
        <Typography variant="h6" className={classes.resultName}>
          {type === 'new' ? `${t('profiling.orgAutocomplete.addNew')} ` : ''}
          {name}
        </Typography>
        {address && <Typography className={classes.resultAddress}>{address}</Typography>}
      </div>
    </div>
  );
};

type Props = {
  searchResults: Object,
  classes: Object,
  query: string,
  onClickOutside: Function,
  onSelectResult: Function,
  orgType: string,
};

const searchResultsList = ({ searchResults, classes, query, onSelectResult, onClickOutside, orgType }: Props) => {
  const ref: any = useRef();

  useOutsideClick(ref, onClickOutside || (() => {}));
  if (!query) return null;
  const hasPerfectMatch =
    searchResults && searchResults.some(result => result.name.toLowerCase() === query.toLowerCase());
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        backgroundColor: 'white',
        border: '0.67069px solid #757575',
        zIndex: 2,
      }}
      ref={ref}
    >
      {searchResults &&
        searchResults.map(result => (
          <SearchResult
            name={result.name}
            address={result.address || ''}
            id={result.id || ''}
            key={result.id}
            classes={classes}
            type={orgType}
            onClick={onSelectResult}
          />
        ))}
      {!hasPerfectMatch && <SearchResult name={query} classes={classes} type="new" onClick={onSelectResult} />}
    </div>
  );
};

export default withStyles(styles)(searchResultsList);
